var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"line-height":"1.1"}},[_vm._v(_vm._s(_vm.newUri))])
}
var staticRenderFns = []

export { render, staticRenderFns }